type PermissionTarget = {
  ownerId: string;
  permissions?: string[];
  membersCanPost?: boolean;
};

function hasPermission(
  userId: string | undefined,
  entity: PermissionTarget | undefined,
  permission: string,
): boolean {
  if (!userId || !entity) {
    return false;
  }

  const isOwner = userId === entity.ownerId;

  return isOwner || entity.permissions?.includes(permission) === true;
}

export function usePermissionChecker(
  userId: string | undefined,
  entity: PermissionTarget | undefined,
) {
  const isOwner = !!userId && !!entity && userId === entity.ownerId;

  const can = (permission: string): boolean =>
    hasPermission(userId, entity, permission);

  return { isOwner, can };
}
